import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer, AlertTriangle } from "lucide-react";
import api from "../lib/api";

const ROLES = ["admin", "manager", "cashier"];

export const PrintStationAlert = ({ user }) => {
  const [st, setSt] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!user || !ROLES.includes(user.role)) return undefined;
    let alive = true;
    const poll = () => api.get("/print/status").then((r) => { if (alive) setSt(r.data); }).catch(() => {});
    poll();
    const t = setInterval(poll, 60000);
    window.addEventListener("print-station-changed", poll);
    return () => { alive = false; clearInterval(t); window.removeEventListener("print-station-changed", poll); };
  }, [user]);
  if (!st || st.disabled) return null;
  const none = !st.device_id;
  const offline = !none && !st.online && st.offline_minutes != null && st.offline_minutes >= 3;
  if (!none && !offline) return null;
  const isAdmin = ["admin", "manager"].includes(user.role);
  return (
    <div data-testid="print-station-alert" className={`px-4 md:px-6 py-2.5 flex flex-wrap items-center gap-3 text-sm text-white ${none ? "bg-[#B45309]" : "bg-[#DC2626]"}`}>
      {none ? <Printer size={18} /> : <AlertTriangle size={18} />}
      <span className="flex-1 min-w-[200px]" data-testid="print-station-alert-text">
        {none
          ? "No hay estación de impresión: las comandas de QR, página web y comandero no se imprimirán."
          : `La estación de impresión "${st.name || "sin nombre"}" lleva ${st.offline_minutes ?? "varios"} min sin conexión.`}
        {st.pending + st.errors > 0 && <b> {st.pending + st.errors} comanda(s) esperando.</b>}
      </span>
      {isAdmin && (
        <button data-testid="print-station-alert-change" onClick={() => navigate("/app/configuracion?tab=cocina")}
          className="h-8 px-3 rounded-lg bg-white/20 hover:bg-white/30 font-semibold">{none ? "Configurar estación" : "Cambiar estación"}</button>
      )}
    </div>
  );
};
